import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartButtonBlockConfig } from '@front-platform/content-builder';
import { cartButtonBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { ModalsService } from '@core/services/modals/modals.service';
import {
  CartOverviewModalComponent,
  CartOverviewModalConfig,
} from '@shared/modals/cart-overview-modal/cart-overview-modal.component';
export interface CartButtonBlockRuntimeConfig {}

export type CartButtonBlockConfigInput = Partial<
  Omit<CartButtonBlockConfig, keyof CartButtonBlockRuntimeConfig> & CartButtonBlockRuntimeConfig
>;
export type CartButtonBlockResolvedConfig = Omit<
  CartButtonBlockConfig,
  keyof CartButtonBlockRuntimeConfig
> &
  Partial<CartButtonBlockRuntimeConfig>;
export interface CartButtonBlockContract extends ConfigComponentContract<
  CartButtonBlockConfigInput,
  CartButtonBlockResolvedConfig
> {}

@Component({
  template: ``,
  selector: 'app-cart-button-block',
  standalone: false,
})
export class CartButtonBlockComponent implements OnInit, OnDestroy, CartButtonBlockContract {
  readonly config = input<CartButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartButtonBlockConfig,
    CartButtonBlockRuntimeConfig
  >(cartButtonBlockResolveConfig, () => ({ config: this.config() }));

  constructor(private readonly modalsService: ModalsService<CartOverviewModalConfig>) {}

  ngOnInit(): void {
    this.modalsService.open(CartOverviewModalComponent.handle);
  }

  ngOnDestroy(): void {
    this.modalsService.close(CartOverviewModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartButtonBlockComponent, { 'keyAliases': {} });
